module.exports = __webpack_public_path__ + "img/mf.3fcb4a6f.png";